export enum MenusPageTabs {
  menusPage = 'menusPage',
  sectionsPage = 'sectionsPage',
  itemsPage = 'itemsPage',
  modifiersPage = 'modifiersPage',
  choicesPage = 'choicesPage',
}
